import React from 'react';

export default {
	path: '/disclaimer',
	components: () => [import('./component')],
	render: ([Disclaimer]) => <Disclaimer />,
};
